import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzResultModule } from 'ng-zorro-antd/result';
import { Error404Component } from './error-404.component';

@NgModule({
  declarations: [Error404Component],
  imports: [
    CommonModule,
    RouterModule,
    NzButtonModule,
    NzResultModule,
  ],
  exports: [Error404Component],
})
export class ErrorsModule { }
